import { SWRConfiguration } from 'swr';

import { UseArraySWROutput, useArraySWR } from '~/hooks/useSWR';
import { NotificationReadApiClient, People } from '~/services/Http';

export const GET_NOTIFICATIONS_SWR_KEY =
  'NotificationReadApiClient.getNotifications';

export type GetNotificationsProps = {
  lang?: string;
  offset?: number;
  limit?: number;
  startDate?: string;
  endDate?: string;
  order?: People.Order18;
  topics?: string[];
};

export function useGetNotifications(
  args?: GetNotificationsProps,
  swrConfig?: SWRConfiguration<People.INotificationDto[]>,
): UseArraySWROutput<People.INotificationDto> {
  return useArraySWR(
    [
      GET_NOTIFICATIONS_SWR_KEY,
      args?.lang ?? undefined,
      args?.offset ?? undefined,
      args?.limit ?? undefined,
      args?.startDate ?? undefined,
      args?.endDate ?? undefined,
      args?.order ?? undefined,
      args?.topics ?? undefined,
    ],
    ([_, lang, offset, limit, order, startDate, endDate, topics]) =>
      NotificationReadApiClient.getNotifications(
        order,
        offset,
        limit,
        startDate,
        endDate,
        lang,
        topics,
      ).then((r) => r.data),
    swrConfig,
  );
}
